import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FormContextProvider, DisplaySpinnerContext } from "../../../context/ContextIndex";
import { AppForm, DynamicFormContainer, notifyToast, ToastType, TabPanel } from "../../../components";
import { getBranchCostConfigDefaultValue, getBranchCostConfigSchema } from "./Schema";
import { selectSessionConfig } from "../../../store/store-selector";
import { saveBranchCostConfig } from "../api-handler/api-handler";
import { useFetchListData } from "../../../hooks/useFetchListData";
import AppFormRootContainer from "../../../components/app-components/app-form-root-container/AppFormRootContainer";

const CreateBranchCostConfigForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const EditBranchId = searchParams.get("BranchId");
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const navigationData = location.state;
  const IcabsBranchList = useFetchListData(settingsConfig.businessCode, settingsConfig.countryCode, "getIcabsBranchList", "branch");

  const [formdata, setFormdata] = useState({
    schema: getBranchCostConfigSchema([{ id: null, label: null }]),
    appformdata: null,
  });

  const defaultValue = getBranchCostConfigDefaultValue();

  const handleCancel = () => {
    try {
      navigate("/branchcostconfiglist");
    } catch (err) {
      alert(err);
    }
  };

  const onBranchCostConfigSubmit = async (data, formhandler) => {
    console.log("onBranchCostConfigSubmit");
    const { reset, clearErrors } = formhandler;
    try {
      clearErrors();
      spinnerCtx.setLoadingIndicator(true);
      const status = await saveBranchCostConfig(data, {
        EditBranchId,
        settingsConfig,
        formdata: formdata.appformdata,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for Approval", ToastType.SUCCESS);
        handleCancel();
      } else {
        notifyToast(status.errorMessage ? status.errorMessage : "Branch Cost Config creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
      if (status?.error) {
        reset(
          { ...data },
          {
            keepValues: true,
            keepSubmitCount: false,
            keepDirty: true,
            keepTouched: true,
          }
        );
      }
    } catch (err) {
      reset(
        { ...data },
        {
          keepValues: true,
          keepSubmitCount: false,
          keepDirty: true,
          keepTouched: true,
        }
      );
      alert(err);
    }
  };

  useEffect(() => {
    const setFormSchema = (recordlist) => {
      try {
        let _icabsBranchList = [];
        if (recordlist.length) {
          let _formData = navigationData ? { ...navigationData } : null;

          _icabsBranchList = recordlist.map((item) => {
            if (_formData && item.BranchNumber === _formData.BranchNumber) {
              _formData.Branch = {
                id: item.BranchNumber,
                label: `${item.BranchNumber} - ${item.BranchName}`,
              };
            }
            return {
              id: item.BranchNumber,
              label: `${item.BranchNumber} - ${item.BranchName}`,
            };
          });

          if (_formData) {
            setFormdata((prevstate) => ({
              ...prevstate,
              schema: getBranchCostConfigSchema(_icabsBranchList),
              appformdata: getBranchCostConfigDefaultValue(_formData),
            }));
          } else {
            setFormdata((prevstate) => ({
              ...prevstate,
              schema: getBranchCostConfigSchema(_icabsBranchList),
            }));
          }
        }

      } catch (err) {
        alert(err);
      } finally {
        spinnerCtx.setLoadingIndicator(false);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    if (IcabsBranchList) {
      setFormSchema(IcabsBranchList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [IcabsBranchList]);

  return (
    <AppFormRootContainer>
      <TabPanel
        tabs={[
          {
            icon: "",
            label: t("createBranchCostConfig.tabHeader"),
            children: (
              <FormContextProvider schema={formdata.schema} defaultValues={defaultValue} appformdata={formdata.appformdata}>
                <AppForm onSubmit={onBranchCostConfigSubmit}>
                  <DynamicFormContainer
                    header={EditBranchId ? t("createBranchCostConfig.editHeader") : t("createBranchCostConfig.createHeader")}
                    onCancel={handleCancel}
                  />
                </AppForm>
              </FormContextProvider>
            ),
          },
        ]}
        selectedTab="0"
        onTabChange={() => { }}
      />
    </AppFormRootContainer>
  );
};

export default CreateBranchCostConfigForm;
